import { errorToast, successToast, helper } from "../../../shared/services/helper.js";

const setWalletStakeValue = (stake, depositAmount, walletConfig) => {
     try {
        depositAmount = parseFloat(depositAmount) || 0;
        stake = parseFloat(stake) || 0;

        depositAmount += stake;
        if(depositAmount > walletConfig?.deposit_range?.max){
            depositAmount = walletConfig?.deposit_range?.max;
        }
        return depositAmount
    } catch (e) {
        errorToast(e)
    }
}


export {
    setWalletStakeValue
}